import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const revertFundingRequestToReview = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "fundingRequests/revertFundingRequestToReview",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.revertFundingRequestToReview(id);
  },
);

export const resetRevertFundingRequestToReview = createAction("fundingRequests/resetRevertFundingRequestToReview");
